import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  landscape: {},
  portrait: {},
  donationsMessage: {
    padding: theme.spacing(2.5),
    color: 'white',
    minHeight: '100%',
    background:
      'linear-gradient(130deg, rgba(235,46,107,1) 0%, rgba(26,163,255,1) 100%)',
    fallbacks: {
      background: 'rgb(235,46,107)'
    }
  },
  donateNowText: {
    fontSize: 40,
    color: 'white',
    lineHeight: '55px',
    textAlign: 'center'
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/DonationsMessage/styles.js